<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="140px">
      <el-form-item label="所属区块链" prop="pid">
        <el-select v-model="dataForm.pid" placeholder="请选择区块链">
          <el-option v-for="item in chainList" :key="item.id" :label="item.chainName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代币代码" prop="tokenCode">
        <el-input v-model="dataForm.tokenCode" placeholder="代币代码,如USDT"></el-input>
      </el-form-item>
      <el-form-item label="代币名称" prop="tokenName">
        <el-input v-model="dataForm.tokenName" placeholder="代币名称,如Tether USD"></el-input>
      </el-form-item>
      <el-form-item label="是否原生币">
        <el-switch v-model="dataForm.isNative" :active-value="1" :inactive-value="0" @change="nativeChangeHandle"></el-switch>
      </el-form-item>
      <el-form-item label="合约地址">
        <el-input v-model="dataForm.contractAddress" :disabled="dataForm.isNative === 1" placeholder="非原生币时必填"></el-input>
      </el-form-item>
      <el-form-item label="收款钱包地址" prop="walletAddress">
        <el-input v-model="dataForm.walletAddress" placeholder="用于接收用户支付的钱包地址"></el-input>
      </el-form-item>
      <el-form-item label="精度" prop="decimals">
        <el-input-number v-model="dataForm.decimals" :min="0" :max="18"></el-input-number>
      </el-form-item>
      <el-form-item label="CoinGecko ID">
        <el-input v-model="dataForm.coingeckoId" placeholder="CoinGecko ID(可选)"></el-input>
      </el-form-item>
      <el-form-item label="订单过期时间" prop="orderExpireMinutes">
        <el-input-number v-model="dataForm.orderExpireMinutes" :min="1" :max="1440" placeholder="分钟(1-1440)"></el-input-number>
      </el-form-item>
      <el-form-item label="回调API地址">
        <el-input v-model="dataForm.ext1" placeholder="如: https://91testapi.asdf.live/api/notify/CryptoDeposit"></el-input>
      </el-form-item>
      <el-form-item label="请求方式">
        <el-select v-model="dataForm.ext2" placeholder="请选择请求方式" clearable>
          <el-option
            v-for="item in requestTypeOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Content-Type">
        <el-select v-model="dataForm.ext3" placeholder="请选择Content-Type" clearable>
          <el-option
            v-for="item in contentTypeOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="启用状态">
        <el-switch v-model="dataForm.isEnabled" :active-value="1" :inactive-value="2"></el-switch>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      chainList: [],
      requestTypeOptions: [],
      contentTypeOptions: [],
      dataForm: {
        id: '',
        pid: '',
        tokenCode: '',
        tokenName: '',
        contractAddress: '',
        walletAddress: '',
        decimals: 18,
        coingeckoId: '',
        isNative: 0,
        isEnabled: 1,
        orderExpireMinutes: 30,
        ext1: '',
        ext2: '',
        ext3: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pid: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        tokenCode: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        tokenName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        walletAddress: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        decimals: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        orderExpireMinutes: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { type: 'number', min: 1, max: 1440, message: '请输入1-1440之间的分钟数', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.getChainList()
        this.getRequestTypeOptions()
        this.getContentTypeOptions()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    getChainList () {
      this.$http.get('/crypto/chain/enabled').then(({ data: res }) => {
        if (res.code === 0) this.chainList = res.data
      }).catch(() => {})
    },
    getRequestTypeOptions () {
      // 第一步: 根据dict_type查询字典类型,获取type_id
      this.$http.get('/sys/dict/type/page', {
        params: { dictType: 'HTTP-request-type', page: 1, limit: 1 }
      }).then(({ data: res }) => {
        if (res.code === 0 && res.data && res.data.list && res.data.list.length > 0) {
          const typeId = res.data.list[0].id
          // 第二步: 根据dict_type_id查询字典数据
          this.$http.get('/sys/dict/data/page', {
            params: { dictTypeId: typeId, page: 1, limit: 100, order: 'asc', orderField: 'sort' }
          }).then(({ data: dataRes }) => {
            if (dataRes.code === 0 && dataRes.data && dataRes.data.list) {
              this.requestTypeOptions = dataRes.data.list.map(item => ({
                dictValue: item.dictValue,
                dictLabel: item.dictLabel
              }))
            }
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    getContentTypeOptions () {
      // 第一步: 根据dict_type查询字典类型,获取type_id
      this.$http.get('/sys/dict/type/page', {
        params: { dictType: 'Content-Type', page: 1, limit: 1 }
      }).then(({ data: res }) => {
        if (res.code === 0 && res.data && res.data.list && res.data.list.length > 0) {
          const typeId = res.data.list[0].id
          // 第二步: 根据dict_type_id查询字典数据
          this.$http.get('/sys/dict/data/page', {
            params: { dictTypeId: typeId, page: 1, limit: 100, order: 'asc', orderField: 'sort' }
          }).then(({ data: dataRes }) => {
            if (dataRes.code === 0 && dataRes.data && dataRes.data.list) {
              this.contentTypeOptions = dataRes.data.list.map(item => ({
                dictValue: item.dictValue,
                dictLabel: item.dictLabel
              }))
            }
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    nativeChangeHandle (val) {
      if (val === 1) {
        this.dataForm.contractAddress = ''
      }
    },
    getInfo () {
      this.$http.get(`/crypto/token/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataForm = { ...this.dataForm, ...res.data }
        }
      }).catch(() => {})
    },
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) return false
        this.$http[!this.dataForm.id ? 'post' : 'put']('/crypto/token', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) return this.$message.error(res.msg)
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
